import { Component, Input } from '@angular/core';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

@Component({
  selector: 'app-vendor-referral-appointment',
  imports: [
    TableComponent,
    ColumnComponent,
    DetailPanelComponent,
    DetailItemComponent,
  ],
  template: ` <app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    recordLabel="Appointment"
    [expandable]="true"
    dataKey="claimAppointmentID"
    theme="Dark"
  >
    <app-column
      label="Appointment Date"
      name="dateAppointment"
      format="d"
      width="17%"
    />
    <app-column
      label="Scheduled Date"
      name="dateScheduled"
      width="17%"
      format="d"
    />
    <app-column
      label="Employer Notified"
      name="dateNotified"
      width="17%"
      format="d"
    />
    <app-column label="Status" name="appointmentStatus" width="15%" />
    <app-column label="Result of Examination" name="resultofExam" width="17%" />
    <app-column label="Service Location" name="placeofService" width="17%" />
    <ng-template #expand let-data>
      <div class="tw-flex tw-gap-8 tw-pb-4">
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="data">
            <app-detail-item
              label="Narrative Date"
              name="dateNarrative"
              format="d"
            />
            <app-detail-item label="Fee" name="fees" format="c" />
            <app-detail-item label="ICD" name="icDcodes" labelCase="none">
              <ng-template #value let-data>
                @if (data.icDcodes && data.icDcodes.length > 0) {
                  @for (icd of data.icDcodes; track icd; let i = $index) {
                    @if (icd !== null && icd !== '') {
                      <div>ICD#{{ i + 1 }}: {{ icd }}</div>
                    }
                  }
                }
              </ng-template>
            </app-detail-item>
            <app-detail-item
              label="Comment"
              name="comment"
              labelPosition="Top"
            />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="data">
            <app-detail-item
              label="Verbal Date"
              name="dateResults"
              format="d"
            />
            <app-detail-item
              label="Scheduled Date"
              name="dateScheduled"
              format="d"
            />
          </app-detail-panel>
        </div>
      </div>
    </ng-template>
  </app-table>`,
  styles: [],
})
export class VendorReferralAppointmentComponent {
  @Input() dataSource: any;
}
